import React from 'react'
import Slider from 'react-slick'

import styled from 'styled-components'
import './slick.css'

const Wrapper = styled.div`
width: 90vw;
margin: 3rem auto;
`

const FeaturedArt = styled.section`
    border-radius: 10px;
    padding: 1rem;
    background-color:#eee;
    max-width: 1200px;
    display: flex;
    align-items: center;
    .media{
        max-height: 50vh;
        overflow-y: hidden;
        img { 
            width: 100%;
            height: 100%;
            object-fit: fill;
        }
    }

    article { 
        font-size: 18px;
        margin: 2rem;


        padding: 10px 20px;
    }

`





const FeaturedCarousel = ({children}) => {

  const settings = {
      infinite: true, 
      speed: 500, 
      slidesToShow: 1,
      slidesToScroll: 1,
  }

  const cards = [
    {
      title:"Creek in the Midlands",
      imageSrc: "https://images.nightcafe.studio/jobs/Beqm8aiHI9NopZdpUAVy/Beqm8aiHI9NopZdpUAVy.jpg?tr=w-1200,c-at_max",
      description: "Ut id reprehenderit veniam labore aute amet aute ex nostrud. Irure consectetur nisi excepteur veniam dolore. Lorem ipsum nisi enim aliqua exercitation dolor culpa irure voluptate mollit. Enim quis eu dolore sit aliquip velit nisi occaecat occaecat officia id. Pariatur ad officia ex amet aliqua pariatur minim aute aliqua pariatur velit sunt aliqua. Aliqua duis ipsum proident excepteur tempor aute nisi quis id nostrud."
    },
    {
        title:"Neurotoxin Grenades", 
        imageSrc:"https://images.nightcafe.studio/jobs/yFhzbZSTjNfsFJpAdB3f/yFhzbZSTjNfsFJpAdB3f.jpg?tr=w-1200,c-at_max",
        description: "Ut id reprehenderit veniam labore aute amet aute ex nostrud. Irure consectetur nisi excepteur veniam dolore. Lorem ipsum nisi enim aliqua exercitation dolor culpa irure voluptate mollit. Enim quis eu dolore sit aliquip velit nisi occaecat occaecat officia id. Pariatur ad officia ex amet aliqua pariatur minim aute aliqua pariatur velit sunt aliqua. Aliqua duis ipsum proident excepteur tempor aute nisi quis id nostrud."
    },
    {
        title:"Exoplanet Landscape", 
        imageSrc:"https://images.nightcafe.studio/jobs/4Man1Uh2wlkF8dj9CIeJ/4Man1Uh2wlkF8dj9CIeJ.jpg?tr=w-1200,c-at_max",
        description: "Ut id reprehenderit veniam labore aute amet aute ex nostrud. Irure consectetur nisi excepteur veniam dolore. Lorem ipsum nisi enim aliqua exercitation dolor culpa irure voluptate mollit. Enim quis eu dolore sit aliquip velit nisi occaecat occaecat officia id. Pariatur ad officia ex amet aliqua pariatur minim aute aliqua pariatur velit sunt aliqua. Aliqua duis ipsum proident excepteur tempor aute nisi quis id nostrud."
    },

]


const rendered =  cards.map( (card,i) => (
    <FeaturedArt key={`card_${i}`}>
        <h2 style={{textAlign:"center"}}>{card.title}</h2>
        <div className='media'>
            <img src={card.imageSrc} alt={card.title} />
        </div>
        <article>{card.description}</article>
    </FeaturedArt>
))

  return (
      <Wrapper>
        <Slider {...settings}>
            { rendered }
        </Slider>
      </Wrapper>
  )
}

export default FeaturedCarousel